import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl, intlShape } from 'react-intl'
import { connect } from 'react-redux'

import FaIcon from './FaIcon'

import { Button, Popconfirm, Tooltip } from 'antd'



class TableButton extends Component {

    static propTypes = {
        session: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }

    handleClick = (e) => {
        if (this.props.onClick) {
            this.props.onClick(this.props.value)
        }
        e.stopPropagation()
    }

    ignoreClick = (e) => {
        e.stopPropagation()
    }

    render() {
        const { intl, session, confirm, className, color, icon } = this.props
        let classes = className ? ' ' + className : ''
        classes += color ? ' ' + color : ''
        let tip = session.user.showHelp ? this.props.tip : null
        if (tip && typeof tip === 'string') {
            tip = intl.formatMessage({id: tip})
        }
        if (confirm) {
            return (
                tip ? <Tooltip title={tip} placement="left">
                        <Popconfirm title={<FormattedMessage id="misc.confirm" />} onConfirm={this.handleClick} okText={intl.formatMessage({id: 'misc.yes'})} cancelText={intl.formatMessage({id: 'misc.no'})}>
                            <Button className={"table-btn" + classes} shape="circle" size="small" onClick={this.ignoreClick}><FaIcon icon={icon} /></Button>
                        </Popconfirm>
                    </Tooltip>
                    : <Popconfirm title={<FormattedMessage id="misc.confirm" />} onConfirm={this.handleClick} okText={intl.formatMessage({id: 'misc.yes'})} cancelText={intl.formatMessage({id: 'misc.no'})}>
                        <Button className={"table-btn" + classes} shape="circle" size="small" onClick={this.ignoreClick}><FaIcon icon={icon} /></Button>
                    </Popconfirm>
                    
            )
        }
        return (
            tip ? <Tooltip title={tip} placement="left"><Button className={"table-btn" + classes} shape="circle" size="small" onClick={this.handleClick}><FaIcon icon={icon} /></Button></Tooltip>
                : <Button className={"table-btn" + classes} shape="circle" size="small" onClick={this.handleClick}><FaIcon icon={icon} /></Button>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    session: state.session
})

export default injectIntl(connect(mapStateToProps)(TableButton))


// WEBPACK FOOTER //
// ./src/components/TableButton.js